import {
  FieldValues,
  Path,
  PathValue,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

export const swapFieldValues = <TFieldValues extends FieldValues = FieldValues>(
  filedName1: Path<TFieldValues>,
  fieldName2: Path<TFieldValues>,
  getValues: UseFormGetValues<TFieldValues>,
  setValue: UseFormSetValue<TFieldValues>
) => {
  const temp = getValues(filedName1);
  setValue(filedName1, getValues(fieldName2));
  setValue(fieldName2, temp);
};

export interface PopulateField<T, FormObj> {
  objectKey: Path<T>;
  formKey: Path<FormObj>;
}

/**
 * To autofill FormObj with values from tObject that may have different named keys.
 * @param mapping The mapping between tObject keys and Form object keys
 * @param tObject The object to map to the form.
 * @param defaultForm The fallback form value, if tObject value is nullable.
 * @param setValue The setValue function from react-hook-form
 */
export const autofillFromObject = <T, FormObj extends FieldValues>(
  mapping: PopulateField<T, FormObj>[],
  tObject: PathValue<FormObj, Path<FormObj>>,
  defaultForm: FormObj,
  setValue: UseFormSetValue<FormObj>
) => {
  mapping.forEach(({ objectKey, formKey }) => {
    setValue(formKey, tObject[objectKey] ?? defaultForm[formKey], {
      shouldValidate: true,
      shouldDirty: true,
    });
  });
};
